module.exports = __webpack_public_path__ + "static/media/ic_curtain_mid.c4ef14f8.png";